import type { OrgShopCurrencyDto } from "@intelligems/ig-types";
import type { RootState } from "@src/store/rootState";
import { getConfiguration } from "./getConfiguration";

export const getCurrencyConfiguration = (state: RootState) =>
  getConfiguration<OrgShopCurrencyDto>("shop_currency")(state);

export const getCountryCode = (state: RootState) =>
  getCurrencyConfiguration(state)?.countryCode;
